import ListItem from "@mui/material/ListItem";
import { styled } from "@mui/material/styles";

const CustomizedComponent = styled(ListItem)(({ theme, onClick }) => ({
  padding: theme.spacing(1),
  paddingTop: 0,
  paddingBottom: 0,
  boxShadow: theme.shadows[3],
  marginBottom: theme.spacing(1),
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.foreground.main,
  color: theme.palette.foreground.contrastText,
  cursor: onClick ? "pointer" : "default",
}));

const WidgetTextListItem = props => {
  const { disableGutters = true, onClick = null, sx = null } = props;
  return (
    <CustomizedComponent disableGutters={disableGutters} onClick={onClick} sx={sx}>
      {props.children}
    </CustomizedComponent>
  );
};

export default WidgetTextListItem;
